import React from 'react'
import { getReviewStatus } from '../../utils/reviewStatusUtils'

interface TestStatusBadgeProps {
  status: string
  auditorReview?: string | any
  isAuditor?: boolean
  className?: string
  auditId?: string
}

const TestStatusBadge: React.FC<TestStatusBadgeProps> = ({ 
  status, 
  auditorReview, 
  isAuditor = false, 
  className = '',
  auditId
}) => {
  const review = getReviewStatus(auditorReview, auditId) || status

  const getLabel = () => {
    if (!isAuditor) {
      return review === 'Deactivated'
        ? 'Deactivated'
        : review === 'Pass'
        ? 'Passing'
        : 'Failing'
    }

    return review === 'Deactivated'
      ? 'Deactivated'
      : review === 'Pass'
      ? 'Ready for audit'
      : review === 'Approved'
      ? 'Approved'
      : review === 'Flagged'
      ? 'Flagged'
      : review === 'Not applicable'
      ? 'Not applicable'
      : 'Not ready for audit'
  }

  const getTextColor = () => {
    if (!isAuditor) {
      return review === 'Deactivated'
        ? '#5A5A5A'
        : review === 'Pass'
        ? '#0E9F6E'
        : '#EE3043'
    }

    return review === 'Deactivated'
      ? '#5A5A5A'
      : review === 'Pass'
      ? '#3B82F6'
      : review === 'Approved'
      ? '#0E9F6E'
      : review === 'Flagged'
      ? '#B85407'
      : review === 'Not applicable'
      ? '#5A5A5A'
      : '#EE3043'
  }

  const getBackgroundColor = () => {
    if (!isAuditor) {
      return review === 'Deactivated'
        ? '#F6F6F6'
        : review === 'Pass'
        ? '#E8F8F4'
        : '#FFF5F8'
    }

    return review === 'Deactivated'
      ? '#F6F6F6'
      : review === 'Pass'
      ? '#E3F0FF'
      : review === 'Approved'
      ? '#E8F8F4'
      : review === 'Flagged'
      ? '#FAE9D2'
      : review === 'Not applicable'
      ? '#F6F6F6'
      : '#FFF5F8'
  }

  const getExtraClasses = () => {
    return review === 'Deactivated' ? 'text-dark text-bold m-1' : ''
  }

  return (
    <span
      className={`badge fs-7 ${getExtraClasses()} ${className}`}
      style={{
        color: getTextColor(),
        background: getBackgroundColor(),
      }}
    >
      {getLabel()}
    </span>
  )
}

export default TestStatusBadge 